import Signed from './Signed';

export default Signed;
